import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { UserBonusEvent, UserBonusEventListRequest } from "../../http/protocol";
import { getContainer } from "../../ioc/IOCSetup";
import { UserBonusEventService } from "../../services/UserBonusEventService";
import { ColumnType } from "../list/list/ColumnType";
import { EntityDataTable } from "../list/list/EntityDataTable";
import { ListUtils } from "../list/list/ListUtils";
import { PagerModel } from "../list/list/PagerModel";
import { ListViewProps, ListViewState } from "../ListView";



interface State extends ListViewState<UserBonusEventListRequest> {
    form? : UserBonusEventListRequest;
    validationMap? : any;
}
interface Props extends ListViewProps  {
    userBonusId:number
}


export class UserBonusEventListView extends React.Component<Props,State> {
    columns = [
        { property : "id", name : "ID"},
        { property : "timestamp", name : "Timestamp", type : ColumnType.DATE},
        { property : "type", name : "Type"},
        { property : "currency", name : "Currency"},
        { property : "amount", name : "Amount"},
        { property : "contribution", name : "Contribution"},
        { property : "product", name : "Product"},
        { property : "status", name : "Status"}
    ];

    actions = [
        
    ];
    
    service : UserBonusEventService;
    
    constructor(props:Props) {
        super(props);
        this.service = getContainer().getUserBonusEventService();
        this.state = {...this.state, 
            validationMap : {}, 
            form : { userBonusId : this.props.userBonusId, limit : 10, offset: 0, orderBy : "timestamp", ascending: false} as any, 
            listRequest: { userBonusId : this.props.userBonusId, limit : 10, offset: 0, orderBy : "timestamp", ascending: false} 
        };
    }

    onSubmitError?: (() => void) | undefined;
    onSubmit() : void | Promise<any> {};

    componenDidUpdate(prevProps: Props, prevState: State){
        console.log("Event list component update", prevProps, prevState, this.props, this.state);
    }
    formDidUpdate(formModel: UserBonusEventListRequest, validationMap?: any): void {
        this.setState({form : formModel, validationMap : validationMap});
    }
    
    getTitle(): string {
        return "";
    }

    onAction(item : UserBonusEvent, action : string) : Promise<any> | undefined {
        return undefined;
    }
    
    pagerChanged(pager : PagerModel) {
        if(!this.state.listRequest) {
            return;
        }
        var listRequest = ListUtils.toListRequest<UserBonusEventListRequest>(this.state.listRequest, pager);
        this.setState({listRequest : listRequest});
    }

    render() {
        if(!this.state.listRequest) {
            return <div/>;
        }
        return(
            <Fragment>
                <EntityDataTable service={this.service}
                                 onPagerChange={this.pagerChanged.bind(this)}
                                 columns={this.columns}
                                 listRequest={this.state.listRequest}
                                 onAction={this.onAction.bind(this)}
                                 actions={this.actions}
                                 customRequest={(request:UserBonusEventListRequest)=>{
                                    return this.service.listUserBonusEvent(request)
                                 }}/>
            </Fragment>
        );
    }
}

export default  withRouter(UserBonusEventListView);
